<template>
  <div v-if="this.$store.state.device.isMobile">
    <b-navbar id="navbarBottom" fixed="bottom" toggleable="lg" type="dark" :style="{'background-color': this.$store.state.device.color, 'background-image': 'linear-gradient('+this.$store.state.device.color+', #2B2D42 150%)'}">
      <b-navbar-nav class="ml-auto navbaritem">
        <b-nav-item href="#">
        <router-link to="/init_menu">
          <div v-if="this.$router.currentRoute.path=='/init_menu'" class="box">
            <img  style="height: 30px; width: 30px"
                  class="menu_icon"
                  src="img/menu.svg"/>
          </div>
          <div v-else>
            <img  style="height: 30px; width: 30px"
                  class="menu_icon"
                  src="img/menu.svg"/>
          </div>
        </router-link>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto navbaritem">
        <b-nav-item href="#">
          <router-link to="/dashboard">
            <div v-if="this.$router.currentRoute.path=='/dashboard'" class="box"><img
                    style="height: 35px; width: 35px; padding: 5px"
                    class="menu_icon"
                    src="img/dashboard.svg"
            /></div>
            <div v-else><img
                    style="height: 35px; width: 35px; padding: 5px"
                    class="menu_icon"
                    src="img/dashboard.svg"
            /></div>
          </router-link>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto navbaritem">
        <b-nav-item href="#"
        ><router-link to="/createSocio">
          <div v-if="this.$router.currentRoute.path=='/createSocio'" class="box">
            <img
                  class="menu_icon"
                  style="height: 30px; width: 30px"
                  src="img/add.svg"/>
          </div>
          <div v-else>
            <img
                    class="menu_icon"
                    style="height: 30px; width: 30px"
                    src="img/add.svg"/>
          </div>
        </router-link>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto navbaritem">
        <b-nav-item href="#"
        ><router-link to="/listPayments">
          <div v-if="this.$router.currentRoute.path=='/listPayments'" class="box">
            <img
                  style="height: 30px; width: 30px"
                  class="menu_icon"
                  src="img/quotas.svg"/>
          </div>
          <div v-else>
            <img
                    style="height: 30px; width: 30px"
                    class="menu_icon"
                    src="img/quotas.svg"/>
          </div>
        </router-link>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto navbaritem">
        <b-nav-item href="#">
        <router-link to="/listSocios">
          <div v-if="this.$router.currentRoute.path=='/listSocios'" class="box">
            <img
                  style="height: 30px; width: 30px"
                  class="menu_icon"
                  src="img/socios.svg"/>
          </div>
          <div v-else>
            <img
                    style="height: 30px; width: 30px"
                    class="menu_icon"
                    src="img/socios.svg"/>
          </div>
        </router-link>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
  export default {
    name: "navbar-bottom"
  };
</script>

<style scoped>
  .box {
    background-color: #8D99AE;
    margin-left: 25%;
    padding: 0;
    display: block;
    width: 50%;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    -webkit-box-shadow: -0.5px -0.5px 3px 0px white;
    -moz-box-shadow: -0.5px -0.5px 3px 0px white;
    box-shadow: -0.5px -0.5px 3px 0px white;
  }
  .menu_icon {
    width: 25px;
    height: 35px;
  }
  #navbarBottom {
    height: 58px;
    padding: 0;
    position: fixed;
    bottom: 0;
  }
  @media (max-width: 989px) {
    .navbaritem {
      width: 20%;
    }
  }
  @media (min-width: 990px) {
    .navbaritem {
      width: 15%;
    }
  }
</style>
